var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7299 4.40748L15.4899 7.92748C15.7299 8.41748 16.3699 8.88748 16.9099 8.97748L20.0999 9.50748C22.1399 9.84748 22.6199 11.3275 21.1499 12.7875L18.6699 15.2675C18.2499 15.6875 18.0199 16.4975 18.1499 17.0775L18.8599 20.1475C19.4199 22.5775 18.1299 23.5175 15.9799 22.2475L12.9899 20.4775C12.4499 20.1575 11.5599 20.1575 11.0099 20.4775L8.01991 22.2475C5.87991 23.5175 4.57991 22.5675 5.13991 20.1475L5.84991 17.0775C5.97991 16.4975 5.74991 15.6875 5.32991 15.2675L2.84991 12.7875C1.38991 11.3275 1.85991 9.84748 3.89991 9.50748L7.08991 8.97748C7.61991 8.88748 8.25991 8.41748 8.49991 7.92748L10.2599 4.40748C11.2199 2.49748 12.7799 2.49748 13.7299 4.40748Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.187c57fc.svg";
export { ForwardRef as ReactComponent };